import * as z from 'zod';

import { responseWithPaginationSchema } from '@/schemas/base';

export const companyResponsibleSchema = z.object({
  id: z.string(),
  name: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  telephone: z.string(),
  imageUrl: z.string().optional(),
});

export const companyTagSchema = z.object({
  id: z.string(),
  label: z.string(),
  value: z.string(),
});

export const companySchema = z.object({
  company: z.object({
    id: z.string(),
    name: z.string(),
    fantasyName: z.string(),
    email: z.string().email().or(z.string().length(0)),
    telephone: z.string(),
    cnpj: z.string(),
    status: z.string(),
    dedicatedDatabase: z.boolean().optional().nullable(),
    address: z.object({
      id: z.string(),
      zipCode: z.string(),
      address: z.string(),
      number: z.string(),
      additionalDetails: z.string(),
      neighborhood: z.string(),
      country: z.string(),
      state: z.string(),
      city: z.string(),
    }),
    more: z.object({
      id: z.string(),
      logoURL: z.string().url().or(z.string().length(0)),
      responsibles: z.array(companyResponsibleSchema).nullable(),
      tags: z.array(companyTagSchema).nullable(),
    }),
  }),
  cvm: z
    .object({
      code: z.number(),
      initialDate: z.string(),
    })
    .optional()
    .nullable(),
  tool: z
    .object({
      webcast: z.boolean(),
      irm: z.boolean(),
      crm: z.boolean(),
      cms: z.boolean(),
      email: z.boolean(),
      ai: z.boolean().optional(),
    })
    .optional()
    .nullable(),
  tickers: z
    .array(
      z.object({
        ticker: z.string(),
        stock_market: z.string(),
        type: z.string(),
        column: z.string(),
      }),
    )
    .optional()
    .nullable(),
});

export const companiesArrSchema = z.array(companySchema).refine((items) => {
  const ids = items.map((item) => item.company.id);
  return ids.length === new Set(ids).size;
}, `ids must be unique`);

export const companiesSchema = responseWithPaginationSchema(
  companiesArrSchema.nullable(),
).nullable();

export const myCompaniesSchema = z.array(companySchema).nullable();

export const companyResponsiblesSchema = z.array(companyResponsibleSchema).nullable();
export const companyTagsSchema = z.array(companyTagSchema).nullable();
